import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'g10-route-cutoff-view',
  templateUrl: './route-cutoff-view.component.html',
  styleUrls: ['./route-cutoff-view.component.css']
})
export class RouteCutoffViewComponent implements OnInit {

  @Input() popup = true;
  @Input() modalTitle = 'Route Cutoff View';
  @Input() data:any;
  @Output() closeEvent = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
    console.log(this.data);
  }

  closePopup() {
    this.closeEvent.emit(true);
  }
}
